import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types';
import { selectedScheme, setSubStage } from '../../../../slices/eligibility/eligibilitySlice';
import { toast } from 'react-toastify';
import Loader from '../../../common/Loader';
import ImageComponent from '../../../common/Image';
import Modal, { ModalHeader, ModalBody } from '../../../common/Modal';
import { Padding } from '@mui/icons-material';
import { toTitleCaseAdvanced } from '../../../../utils/functions';

function Scheme({ data }) {

    const href = "#"
    const dispatch = useDispatch()
    const { schemeData } = useSelector(state => state?.eligibility)
    const [showModal, setShowModal] = useState(false)
    const { dealerCode } = useSelector(state => state.dashboard);
    const sku_id = data?.jsonData?.sku_create_id;
    const [loader, setLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [schemeList, setSchemeList] = useState([]);
    const [selectedSchemeType, setSelectedSchemeType] = useState("standard");
    const urlParams = new URLSearchParams(window.location.search);
    const referenceId = urlParams.get('referenceId');

    const getPreferredSchemeType = (data) => {
        if (!Array.isArray(data) || data.length === 0) return "standard";

        const isAllFixed = data.every(
            item => item?.scheme_type?.toUpperCase() === "FIXED"
        );

        return isAllFixed ? "fixed" : "standard";
    };

    useEffect(() => {
        if (schemeData?.length) {
            setSelectedSchemeType(getPreferredSchemeType(schemeData));
        }
    }, [schemeData]);


    const submitScheme = async (data) => {
        let schemeData = {
            "scheme_id": data?.scheme_id,
            "reference_id": referenceId,
            "dealer_code": dealerCode?.split('-')[0]?.trim(),
            "sku_id": sku_id
        }
        setLoader(true);
        const response = await dispatch(selectedScheme(schemeData));
        setLoader(false);
        if (response?.payload?.response_code === 'S100') {
            dispatch(setSubStage("emi_plan"));
        } else {
            !response?.payload?.error &&
                toast.error(response?.payload?.response_string, {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined
                });
        }
    }

    const filteredSchemeData = Array.isArray(schemeData)
        ? schemeData.filter(item => item.scheme_type?.toLowerCase() === selectedSchemeType?.toLowerCase())
        : [];


    // Check if data exists for each scheme type
    const hasStandardData = Array.isArray(schemeData)
        ? schemeData.some(item => item.scheme_type?.toLowerCase() === 'standard')
        : false;

    const hasFixedData = Array.isArray(schemeData)
        ? schemeData.some(item => item.scheme_type?.toLowerCase() === 'fixed')
        : false;

    const hasCIBData = Array.isArray(schemeData)
        ? schemeData.some(item => item.scheme_type?.toLowerCase() === 'cib')
        : false;

    const hasLCEMIData = Array.isArray(schemeData)
        ? schemeData.some(item => item.scheme_type?.toLowerCase() === 'lcemi')
        : false;


    // Add radio button change handler
    const handleSchemeTypeChange = (e) => {
        setSelectedSchemeType(e.target.value);
    };

    // Get badge class based on label
    const getBadgeClass = (label) => {
        switch (label) {
            case 'Most Popular':
                return 'custom-badge most-popular-tag';
            case 'Low EMI':
                return 'custom-badge low-emi-tag';
            case 'Low DP':
                return 'custom-badge low-dp-tag';
            default:
                return 'custom-badge most-popular-tag';
        }
    };

    return (
        <>
            <div className="col-md-9 col-sm-12 Side-bank-Right variant-div">
                <div
                    className="d-flex justify-content-between"
                    role="button"
                    tabIndex={0}
                    onClick={() => dispatch(setSubStage("variant"))}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            dispatch(setSubStage("variant"));
                        }
                    }}
                >
                    <p className=" Pname-i text-decoration-none text-dark small">...
                        <span className="icon-arrowright-L1 blue"></span>
                        <a href={href} className="text-decoration-none blue fs-14"> Scheme Details</a></p>
                </div>

                <div className="row gy-4">
                    <div className="col-md-6 col-lg-3">

                        <div className="form-group mt-3">
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="inlineRadioOptions" defaultChecked id="inlineRadio2" value="standard"
                                    checked={selectedSchemeType === 'standard'}
                                    onChange={handleSchemeTypeChange}
                                    disabled={!hasStandardData} />
                                <label className={`form-check-label ${!hasStandardData ? 'text-muted' : ''}`} htmlFor="inlineRadio2">Standard</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="lcemi"
                                    checked={selectedSchemeType === 'lcemi'}
                                    onChange={handleSchemeTypeChange}
                                    disabled={!hasLCEMIData} />
                                <label className={`form-check-label ${!hasLCEMIData ? 'text-muted' : ''}`} htmlFor="inlineRadio1">LCEMI</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="cib"
                                    checked={selectedSchemeType === 'cib'}
                                    onChange={handleSchemeTypeChange}
                                    disabled={!hasCIBData} />
                                <label className={`form-check-label ${!hasCIBData ? 'text-muted' : ''}`} htmlFor="inlineRadio1">CIB</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="fixed"
                                    checked={selectedSchemeType === 'fixed'}
                                    onChange={handleSchemeTypeChange}
                                    disabled={!hasFixedData} />
                                <label className={`form-check-label ${!hasFixedData ? 'text-muted' : ''}`} htmlFor="inlineRadio1">Fixed</label>
                            </div>
                        </div>
                    </div>
                    {filteredSchemeData.length > 0 ? (
                        filteredSchemeData.map((data, index) => (
                            <div className="col-12 col-lg-12 col-md-12" key={data?.id || index}>
                                <div className="product-details px-3 py-1">
                                    {data?.label && <div className="text-end tag-div"><span className={getBadgeClass(data?.label)}>{data?.label}</span></div>}
                                    <div className="d-flex align-items-center justify-content-between scheme-content">
                                        {data?.scheme_type?.toLowerCase() !== 'fixed' && <div className="schema-num">{`${data?.tenure}|${data?.advance_emi_tenure}`}</div>}
                                        {data?.scheme_type?.toLowerCase() === 'fixed' && <div className="schema-fixed-num">{`${data?.emi_amount}`}<br/><hr className='fixed-hr'/>{`${data?.advance_emi_tenure} ADV`}</div>}
                                        <div
                                            className="lh-sm scheme-center-content"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => submitScheme(data)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    submitScheme(data);
                                                }
                                            }}
                                        >
                                            <p className="fw-semibold">{data?.scheme_name}</p>
                                            <p className="text-secondary text-nowrap">
                                                EMI - {+data?.tenure - +data?.advance_emi_tenure} X {data?.emi_amount ? <><span className="font-serif mx-0">₹</span>{Number(data?.emi_amount).toLocaleString('en-IN')}</> : "-"}&nbsp;&nbsp;
                                                DP - {data?.downpayment ? <><span className="font-serif mx-0">₹</span>{Number(data?.downpayment).toLocaleString('en-IN')}</> : "-"}
                                            </p>
                                        </div>
                                        <ImageComponent
                                            fileName="i-icon.svg"
                                            alt="Description of icon"
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => {
                                                setShowModal(data);
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    setShowModal(data);
                                                }
                                            }}
                                            style={{ cursor: 'pointer' }}
                                            className="align-self-end"
                                        />
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-12">
                            <div className="text-center py-4">
                                <p className="text-muted">No data found</p>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {showModal && createPortal(
                <>
                    <div className="modal fade show" id="detailicon" tabIndex="-1" aria-labelledby="detailicon" style={{ display: "block", padding: "0px" }} aria-hidden="true">
                        <div className="modal-dialog bottom-modal">
                            <div className="modal-content blue scheme-popup-details">
                                <div className="d-flex align-items-center justify-content-between px-3 py-3 pb-0">
                                    <span className="mb-1 text-secondary scheme-info-title"><i className='icon-EssetionalInformation-1 me-2' />{(showModal?.brand) + `_` + (showModal?.description)}</span>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={() => { setShowModal(false) }} aria-label="Close"></button>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-12 col-md-12">
                                        <div className="px-3 py-3">
                                            <div className="d-flex">
                                                <div className="schema-num me-4">{`${showModal?.tenure}/${showModal?.advance_emi_tenure}`}</div>
                                                <div className="lh-sm">
                                                    <p className="fw-semibold">{showModal?.scheme_name}</p>
                                                    <p className="text-secondary">EMI - {+showModal?.tenure - +showModal?.advance_emi_tenure} X {showModal?.emi_amount ? <><span className="font-serif mx-0">₹</span>{Number(showModal?.emi_amount).toLocaleString('en-IN')}</> : "-"}   DP - {showModal?.downpayment ? <><span className="font-serif mx-0">₹</span>{Number(showModal?.downpayment).toLocaleString('en-IN')}</> : "-"}</p>
                                                </div>
                                            </div>
                                            <div className="mt-2 border-top mb-3">
                                                <div className="row mt-2">
                                                    <div className="col-12 col-lg-12 d-none col-md-12">
                                                        <p className="text-secondary d-flex justify-content-between">OEM Name <span
                                                            className="text-dark fw-semibold text-end">{toTitleCaseAdvanced(showModal?.brand)}</span></p>
                                                    </div>
                                                    <div className="col-12 col-lg-12 col-md-12">
                                                        <p className="text-secondary d-flex justify-content-between">Finance Amount <span
                                                            className="text-dark fw-semibold text-end">{showModal?.finance_amount ? <><span className="font-serif mx-1">₹</span>{Number(showModal?.finance_amount).toLocaleString('en-IN')}</> : "0"}</span></p>
                                                    </div>
                                                    <div className="col-12 d-none col-lg-12 col-md-12">
                                                        <p className="text-secondary d-flex justify-content-between">Product Name <span
                                                            className="text-dark fw-semibold text-end">{toTitleCaseAdvanced(showModal?.category)}</span></p>
                                                    </div>
                                                    <div className="col-12 col-lg-12 col-md-12">
                                                        <p className="text-secondary d-flex justify-content-between">Interest Payable at Disbursement <span
                                                            className="text-dark fw-semibold text-end">{showModal?.interest_at_disbursement ? <><span className="font-serif mx-1">₹</span>{Number(showModal?.interest_at_disbursement).toLocaleString('en-IN')}</> : "0"}</span></p>
                                                    </div>
                                                    <div className="col-12 col-lg-12 col-md-12">
                                                        <p className="text-secondary d-flex justify-content-between">Margin Money <span
                                                            className="text-dark fw-semibold text-end">{showModal?.margin_money ? <><span className="font-serif mx-1">₹</span>{Number(showModal?.margin_money).toLocaleString('en-IN')}</> : "0"}</span></p>
                                                    </div>
                                                    <div className="col-12 col-lg-12 col-md-12">
                                                        <p className="text-secondary d-flex justify-content-between">Admin & Processing Fee <span
                                                            className="text-dark fw-semibold text-end">{showModal?.processing_fee ? <><span className="font-serif mx-1">₹</span>{Number(showModal?.processing_fee).toLocaleString('en-IN')+"*"}</> : "0"}</span></p>
                                                    </div>
                                                    <div className="col-12 col-lg-12 col-md-12">
                                                        <p className="text-secondary d-flex justify-content-between">Amount of Initial Installments <span
                                                            className="text-dark fw-semibold text-end">{showModal?.advance_emi_amount ? <><span className="font-serif mx-1">₹</span>{Number(showModal?.advance_emi_amount).toLocaleString('en-IN')}</> : "0"}</span></p>
                                                    </div>
                                                    <div className="col-12 d-none col-lg-12 col-md-12">
                                                        <p className="text-secondary d-flex justify-content-between">Total Interest Payable <span
                                                            className="text-dark fw-semibold text-end">{showModal?.total_interest_payable ? <><span className="font-serif mx-1">₹</span>{Number(showModal?.total_interest_payable).toLocaleString('en-IN')}</> : "0"}</span></p>
                                                    </div>
                                                    <div className="col-12 mt-2 col-lg-12 col-md-12">
                                                        <p className="text-secondary d-flex downpayment-final-text justify-content-between">*Subject to change basis loan amount</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                </>,
                document.body
            )}
            {loader && <Loader />}
        </>
    )
}

// ✅ PropTypes validation for SonarLint/ESLint
Scheme.propTypes = {
    data: PropTypes.shape({
        jsonData: PropTypes.shape({
            sku_create_id: PropTypes.string
        })
    }).isRequired
};

export default Scheme